import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useQueryClient } from '@tanstack/react-query';

export type DeleteProjectConfirmationProps = {
  isOpen: boolean;
  handleOpen: (boolean: boolean) => void;
  projectId: string;
  onProjectDeleted: (id: string) => void;
};

export const DeleteProjectConfirmation = ({
  isOpen,
  handleOpen,
  projectId,
  onProjectDeleted
}: DeleteProjectConfirmationProps) => {
  const queryClient = useQueryClient();
  const [deletingProject, setDeletingProject] = useState(false);

  return (
    <AlertDialog open={isOpen} onOpenChange={handleOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone. This will permanently delete this
            project and remove all the data inside it from our servers.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={async e => {
              e.preventDefault();
              setDeletingProject(true);
              await deleteProject(projectId);
              setDeletingProject(false);
              handleOpen(false);
              onProjectDeleted(projectId);
            }}
            disabled={deletingProject}
            className="bg-red-600 hover:bg-red-500 dark:text-white dark:hover:bg-red-700"
          >
            {deletingProject ? 'Processing...' : 'Continue'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
